export const actions = {
    ADD_PROJECT_ACTIVITY: 'ADD_PROJECT_ACTIVITY',
    ADD_PROJECT_SET_ACTIVITY: 'ADD_PROJECT_SET_ACTIVITY',
    SET_PROJECT_DATA_DEFAULT: 'SET_PROJECT_DATA_DEFAULT',
    ADD_PROJECT_UPDATE_ACTIVITY: 'ADD_PROJECT_UPDATE_ACTIVITY',
    DELETE_PROJECT_ACTIVITY: 'DELETE_PROJECT_ACTIVITY',
    DELETE_PROJECT_SET_ACTIVITY: 'DELETE_PROJECT_SET_ACTIVITY',

    UPDATE_PROJECT_ACTIVITY: 'UPDATE_PROJECT_ACTIVITY',
    SET_UPDATE_PROJECT_ACTIVITY: 'SET_UPDATE_PROJECT_ACTIVITY',
    
    GET_USER_ADD_MODAL: 'GET_USER_ADD_MODAL',
    SET_USER_ADD_MODAL: 'SET_USER_ADD_MODAL',

    GET_PROJECT_ADD_GROUP: 'GET_PROJECT_ADD_GROUP',
    SET_PROJECT_ADD_GROUP: 'SET_PROJECT_ADD_GROUP',

    GET_PROJECT_AUTO_ADD_GROUP: 'GET_PROJECT_AUTO_ADD_GROUP',
    SET_PROJECT_AUTO_ADD_GROUP: 'SET_PROJECT_AUTO_ADD_GROUP',

    GET_PROJECT_UPDATE_GROUP: 'GET_PROJECT_UPDATE_GROUP',
    SET_PROJECT_UPDATE_GROUP: 'SET_PROJECT_UPDATE_GROUP',

    
    GET_PROJECT_DELETE_GROUP: 'GET_PROJECT_DELETE_GROUP',
    SET_PROJECT_DELETE_GROUP: 'SET_PROJECT_DELETE_GROUP',

    GET_PROJECT_ADD_USERS_TO_GROUP: 'GET_PROJECT_ADD_USERS_TO_GROUP',
    SET_PROJECT_ADD_USERS_TO_GROUP: 'SET_PROJECT_ADD_USERS_TO_GROUP',

    GET_PROJECT_FETCH_ALL_GROUPS: 'GET_PROJECT_FETCH_ALL_GROUPS',
    SET_PROJECT_FETCH_ALL_GROUPS: 'SET_PROJECT_FETCH_ALL_GROUPS',
    
    GET_PROJECT_FETCH_USERS_OF_GROUP: 'GET_PROJECT_FETCH_USERS_OF_GROUP',
    SET_PROJECT_FETCH_USERS_OF_GROUP: 'SET_PROJECT_FETCH_USERS_OF_GROUP',

    PROJECT_UPDATE_GROUP: 'PROJECT_UPDATE_GROUP',
    PROJECT_DELETE_GROUP: 'PROJECT_DELETE_GROUP',
};
